import React from 'react'
import { Image } from "react-bootstrap";
import NumberFormat from 'react-number-format';
import { useTranslation } from '../../hooks/useTranslation';

function CompanyProductSummaryDesktop({ getProdName, currencyCode, getTotalPrice, getCurrency, currentProduct, itemCount }) {
  const { t } = useTranslation();

  return (
    <div className="company-shop-item hidden-mobile">
      {currentProduct.images && currentProduct.images.length > 0 ? <Image className="comp-gift-img" alt={getProdName()} src={currentProduct.images[0].fullURL} /> : null}
      <div className="comp-item-description pe-4">
        <span role="application" aria-roledescription={t("ReservationDetails")} aria-label={getProdName()} dangerouslySetInnerHTML={{ __html: getProdName() }}></span>
        <div
          role="application"
          aria-roledescription={t("ReservationDetails")}
          aria-label={`${t("Price")} ${currentProduct.productPriceAfterDiscount + getCurrency()}`} className="d-flex justify-content-between">
          <span className="comp-item-price">{t("Price")}</span>
          <NumberFormat className="comp-item-price"
            value={currentProduct.productPriceAfterDiscount.toFixed(0)}
            displayType={'text'}
            thousandSeparator={true}
            prefix={currencyCode.replace("ILS", "₪")}
          />
        </div>
        <div role="application" aria-roledescription={t("ReservationDetails")} aria-label={`${t("Quantity")} ${itemCount}`} className="d-flex justify-content-between">
          <span className="quantity">{t("Quantity")}</span>
          <span>{itemCount}</span>
        </div>
        <div role="application" aria-roledescription={t("ReservationDetails")}
          aria-label={`${t("Total")} ${getTotalPrice().toFixed(2) + (currencyCode)}`}
          className="d-flex justify-content-between">
          <span>{t("Total")}</span>
          <NumberFormat className="prod-prc"
            value={getTotalPrice().toFixed(2)}
            displayType={'text'}
            thousandSeparator={true}
            prefix={currencyCode.replace("ILS", "₪")}
          />
        </div>
      </div>
    </div>
  )
}

export default CompanyProductSummaryDesktop